import React from 'react';
import { AppGridLayout, AppTable, AppTableSearch, 
    AppSearchItem, AppFilter } from 'qcc';
import {AppAction} from 'qcc';

export default class extends React.Component<{organId?:number,isMult?:boolean}> {

    state = {}

    getSelected = () =>{
        return this.refGrid.current.state.refTable.getSelected();
    }

    refGrid = React.createRef<AppGridLayout>();

	render() {
        let {organId,isMult} = this.props
		return (
        <AppGridLayout ref={this.refGrid} style={{padding:0}}>
            <AppGridLayout.SearchArea>
                <AppTableSearch>
                    <AppTableSearch.Common>
                        <AppSearchItem.SearchInput placeholder='请录入姓名' keyName='common' field='name'/>
                    </AppTableSearch.Common>
                </AppTableSearch>
            </AppGridLayout.SearchArea>
            <AppGridLayout.GridArea>
                <AppTable paging 
                        sqlId='sql.user.grid' 
                        orderBy='a.id'
                        onBeforeApi = { () =>{ return organId !== undefined && organId !== 0  }}
                        queryDataList = {getOrganFilter(organId)}
                >
                    {isMult?<AppTable.ColCheckbox />:null}
                    <AppTable.ColIndex />
                    <AppTable.Col title='名称' field='name'  width={100}/>
                    <AppTable.Col title='账号' field='account' width={120} />
                    <AppTable.Col title='组织' field='organ' />
                </AppTable>
            </AppGridLayout.GridArea>
        </AppGridLayout>)
	}
}

const getOrganFilter  = (organId:number) =>{
    return [{  
        keyName:'organId',
        lable:'',
        field:'organ_id',
        min:'',
        max:'',
        opr:'organ_collection',
        value:`${organId}`,
        list:[],
        searchItemType:'projectFilter'
    }] as AppFilter[]
}


// WEBPACK FOOTER //
// ./src/page/public/AppUserSelectGrid.tsx